module.exports = __webpack_public_path__ + "files/c4ca58af3bb52d16791c14b6816be453.png";